import React from 'react';

import {
  privatePensionCategoriesQuery,
  privatePensionProductsQuery,
} from '../../../../../../store/managementAnalysisDetails/selector';
import { DynamicProductTable } from '../../DynamicProductTable';
import { ProductTableProps } from '../../DynamicProductTable/constants';

import { getPrivatePensionFilters, tableHead } from './constants';
import ProductItem from './item';

export const PrivatePensionTable = (props: ProductTableProps) => {
  return (
    <DynamicProductTable
      {...props}
      ProductItem={ProductItem}
      productsQuery={privatePensionProductsQuery}
      productCategoryQuery={privatePensionCategoriesQuery}
      productsFiltersGetter={getPrivatePensionFilters}
      tableHeadItems={tableHead}
      tabletColumns={3}
      mobileFields={[
        { key: 'customerNormalized', label: 'Cliente' },
        { key: 'assetNormalized', label: 'Ativo' },
        { key: 'fundCNPJNormalized', label: 'CNPJ Fundo' },
        { key: 'classificationNormalized', label: 'Classificação' },
        { key: 'taxNormalized', label: 'Tributação' },
        { key: 'participantNormalized', label: 'Participante' },
        { key: 'planNormalized', label: 'Plano' },
        { key: 'positionDateNormalized', label: 'Data posição' },
        { key: 'grossValueNormalized', label: 'Valor bruto' },
      ]}
    />
  );
};
